import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import type { ButtonHTMLAttributes } from 'react';
import React from 'react';

type Props = {
    direction: 'left' | 'right';
    variant?: 'transparent' | 'white';
} & ButtonHTMLAttributes<HTMLButtonElement>;

export function NavButton({ variant = 'transparent', direction, ...props }: Props) {
    return (
        <button
            className={clsx('nav-btn', variant)}
            {...props}
        >
            {direction === 'left' && <LeftOutlined size={20} />}
            {direction === 'right' && <RightOutlined size={20} />}
        </button>
    );
}
